import { YtaApiClient } from "@alexanderathoodly/data-models"

const api = new YtaApiClient({
    staging: process.env.GATSBY_ORIGIN !== "https://yta.se",
})

export { api }
